export const LOGO_SRC = `${process.env.PUBLIC_URL}/omorfia-logo.png`;

export const FACIAL_IMAGES = {
  hero: `${process.env.PUBLIC_URL}/images/facials/facial-hero.jpg`,
  hydra: `${process.env.PUBLIC_URL}/images/facials/hydra-facial.jpg`,
  led: `${process.env.PUBLIC_URL}/images/facials/led-light-therapy.jpg`,
  plasma: `${process.env.PUBLIC_URL}/images/facials/plasma-facial.jpg`,
  aromatic: `${process.env.PUBLIC_URL}/images/facials/aromatic-facial.jpg`,
  nir: `${process.env.PUBLIC_URL}/images/facials/nir-facial.jpg`,
  poreCleansing: `${process.env.PUBLIC_URL}/images/facials/pore-cleansing.jpg`,
};
